// extracted by mini-css-extract-plugin
export default {"aiAnalyticsPageContainer":"KpiAiAnalytics_aiAnalyticsPageContainer__0Lrhf","aiPage":"KpiAiAnalytics_aiPage__C2bJ-"};